import React from "react";

const DirectoryOffice = ({ administrative_office_hours: hours }) => (
    <div></div>
);

export default DirectoryOffice;